export default __webpack_public_path__ + "static/media/LogoWhite.a94d7b01.svg";